import { DateRange, Option } from '@types';
import {
  DateFormat,
  formatISODate,
  getStartAndEndDateOfLastMonth,
  getStartAndPresentDateOfCurrentMonth
} from '@utils/date';

import { ReportDateRangeOptionEnum } from './constants';

const getCurrentFinancialYear = (): { startDate: Date; endDate: Date } => {
  const now = new Date();
  const currentYear = now.getFullYear();

  let startDate: Date;
  let endDate: Date;

  if (now.getMonth() + 1 >= 4) {
    // If the current month is April or later
    startDate = new Date(currentYear, 3, 1); // Current year April 1st
    endDate = new Date(); // current date
  } else {
    startDate = new Date(currentYear - 1, 3, 1); // Last year April 1st
    endDate = new Date(currentYear, 2, 31); // Current year March 31st
  }

  return { startDate, endDate };
};

const getLastFinancialYear = (): { startDate: Date; endDate: Date } => {
  const now = new Date();
  const currentYear = now.getFullYear();

  let startDate: Date;
  let endDate: Date;

  if (now.getMonth() + 1 >= 4) {
    // If the current month is April or later
    startDate = new Date(currentYear - 1, 3, 1); // Last year April 1st
    endDate = new Date(currentYear, 2, 31); // Current year March 31st
  } else {
    startDate = new Date(currentYear - 2, 3, 1); // Two years ago April 1st
    endDate = new Date(currentYear - 1, 2, 31); // Last year March 31st
  }

  return { startDate, endDate };
};

const renderDateRangeOption = (
  label: string,
  dateRange: DateRange,
  format: DateFormat = 'MMMM YYYY'
) => {
  const formattedYearDateRange = `${formatISODate({
    date: dateRange.startDate,
    format: 'YYYY'
  })}-${formatISODate({
    date: dateRange.endDate,
    format: 'YYYY'
  })}`;

  return (
    <div className="flex justify-between text-base">
      <div className="text-darkGrey">{label}</div>
      <div className="text-grey">
        {format === 'MMMM YYYY' &&
          formatISODate({
            date: dateRange.startDate,
            format
          })}
        {format === 'YYYY' && formattedYearDateRange}
      </div>
    </div>
  );
};

export const ReportDateRangeOptions: Option[] = [
  {
    key: ReportDateRangeOptionEnum.THIS_MONTH,
    value: 'Current Month',
    element: renderDateRangeOption(
      'Current Month',
      getStartAndPresentDateOfCurrentMonth(),
      'MMMM YYYY'
    )
  },
  {
    key: ReportDateRangeOptionEnum.LAST_MONTH,
    value: 'Last Month',
    element: renderDateRangeOption(
      'Last Month',
      getStartAndEndDateOfLastMonth(),
      'MMMM YYYY'
    )
  },
  {
    key: ReportDateRangeOptionEnum.CURRENT_FINANCIAL_YEAR,
    value: 'Current Financial Year',
    element: renderDateRangeOption(
      'Current Financial Year',
      getCurrentFinancialYear(),
      'YYYY'
    )
  },
  {
    key: ReportDateRangeOptionEnum.LAST_FINANCIAL_YEAR,
    value: 'Last Financial Year',
    element: renderDateRangeOption(
      'Last Financial Year',
      getLastFinancialYear(),
      'YYYY'
    )
  }
];

export { getCurrentFinancialYear, getLastFinancialYear };
